import { useLocation, useNavigate } from 'react-router';
import { MixerLoader, PdfViewer } from '../../Common';
import { useEffect, useState } from 'react';
import { useResizeListener } from '../../../hooks/windowEvents/useResizeListener';
import { useTranslation } from '../../../hooks/useTranslation';

export const SingleInvoicePreviewMobile = () => {
    const initialInvoice = useLocation().state?.invoice;
    const [isLoading, setIsLoading] = useState<boolean>(false);
    const isMobile = useResizeListener().isMaxWidthLarge;
    const navigate = useNavigate();
    const { t } = useTranslation('invoice');

    useEffect(() => {
        if (initialInvoice?.fileUrl) {
            setIsLoading(true);
        }
    }, [initialInvoice]);

    useEffect(() => {
        if (!isMobile) {
            navigate('/invoices/invoice-list');
        }
    }, [isMobile]);

    const backToSelection = () => {
        navigate('/invoices/invoice-list');
    };

    return isLoading ? (
        <div className="invoice-single-preview">
            {initialInvoice?.id && (
                <div className="invoice-single-preview__header">
                    <div onClick={backToSelection} className="invoice-single-preview__header__back-button">
                        <img src="/svg/common/back-arrow.svg" alt="back-arrow"></img>
                        <p>{t('backToSelection')}</p>
                    </div>
                    <div className="invoice-single-preview__header__title-container">
                        <h1>{initialInvoice?.number}</h1>
                        <h4>{initialInvoice?.clientName}</h4>
                    </div>
                </div>
            )}
            <div className="container-with-sidebar-cards__content-invoice">
                <PdfViewer key={initialInvoice?.fileUrl} url={initialInvoice?.fileUrl ? initialInvoice?.fileUrl : ''} />
            </div>
        </div>
    ) : (
        <MixerLoader position="centerOnParent" />
    );
};
